'use client'

import { Button } from "@/components/elements/Button"
import EmptyState from "@/components/elements/EmptyState"
import BlogCard from "../blog/BlogCard"
import { BookOpenText, ChevronRight } from "lucide-react"
import { navigateUrl } from "@/utils/client-request"
import { usePathname } from "next/navigation"

export default function Blogs({ blogs, title, limit, description }: { blogs: any[], title?: string, limit?: number, description?: string }) {
  const pathname = usePathname()
  const displayBlogs = limit ? blogs.slice(0, limit) : blogs
  return (
    <div className="cont py-4 sm:py-8">
      <div className="flex items-center justify-between gap-2 mb-4">
        <div className="flex flex-col gap-1">
          <div className="text-foreground text-xl sm:text-3xl leading-6 sm:leading-9 font-semibold tracking-[-0.75%]">{title || 'Нийтлэл'}</div>
          {description && <div className="text-muted-foreground font-normal text-sm leading-5 sm:text-lg sm:leading-7 tracking-[.0125em]">{description}</div>}
        </div>
        <div className="hidden sm:block">
          <Button tag="a" href={navigateUrl("/blog", pathname)} variant="ghost" icon={ChevronRight} iconPosition="right">
            Бүгдийг харах
          </Button>
        </div>
      </div>
      {displayBlogs?.length > 0 ? (
        <div className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-4 gap-y-4 mt-4`}>
          {displayBlogs.map((blog: any, index: number) => (
            <BlogCard key={blog.id} blog={blog} index={index} />
          ))}
        </div>
      ) : (
        <EmptyState icon={BookOpenText} title="Нийтлэл хоосон байна" description="Яг одоогоор нийтлэл оруулаагүй байна. Хэсэг хугацааны дараа дахин шалгана уу." />
      )}
      <div className="flex items-center justify-center sm:hidden mt-10">
        <Button tag="a" href={navigateUrl("/blog", pathname)} variant="outline" width="full" icon={ChevronRight} iconPosition="right">
          Бүгдийг харах
        </Button>
      </div>
    </div>
  )
}